module.exports = __webpack_public_path__ + "static/img/智能风险评估2_产品截图_image@2x.d147b6cb.png";